﻿import React from 'react';

declare const feather;

const customIcons = {
    weight: '<path d="M512 128a170.666667 170.666667 0 0 1 170.666667 170.666667c0 31.146667-8.106667 60.16-23.04 85.333333H768c40.533333 0 74.666667 28.586667 83.2 66.56C936.96 792.32 938.666667 801.28 938.666667 810.666667a85.333333 85.333333 0 0 1-85.333334 85.333333H170.666667a85.333333 85.333333 0 0 1-85.333334-85.333333c0-9.386667 1.706667-18.346667 87.466667-360.106667C181.333333 412.586667 215.466667 384 256 384h108.373333A165.973333 165.973333 0 0 1 341.333333 298.666667a170.666667 170.666667 0 0 1 170.666667-170.666667m0 85.333333a85.333333 85.333333 0 0 0-85.333333 85.333334 85.333333 85.333333 0 0 0 85.333333 85.333333 85.333333 85.333333 0 0 0 85.333333-85.333333 85.333333 85.333333 0 0 0-85.333333-85.333334M385.706667 658.773333L443.733333 768h72.96l-87.04-142.506667 80.213334-116.053333H435.2l-56.746667 101.973333h-20.48v-101.973333H297.386667V768h60.586666v-109.226667h27.733334m352.853333 73.386667v-95.146667h-100.693333v47.36h40.533333v32l-14.933333 5.973334-26.026667 2.986666c-14.933333 0-26.88-6.4-35.413333-17.066666-8.106667-11.093333-12.373333-25.6-12.373334-43.093334v-53.333333c0-17.493333 4.266667-31.573333 12.8-42.24 8.533333-11.093333 19.626667-16.213333 33.706667-16.213333s25.173333 3.413333 31.146667 10.24c6.826667 6.826667 11.093333 17.066667 13.226666 30.72h56.32l0.426667-1.28c-2.133333-26.88-11.946667-48.213333-28.16-64-16.64-15.36-41.813333-23.04-75.093333-23.04-30.72 0-55.466667 9.813333-75.093334 29.44-19.626667 19.2-29.44 45.226667-29.44 76.373333v53.76c0 31.573333 10.24 57.173333 30.293334 76.8 19.626667 19.626667 45.653333 29.44 77.653333 29.44 25.173333 0 46.506667-3.84 63.146667-11.946667 16.64-8.106667 29.44-17.066667 37.973333-27.733333z" fill="" />'
}

function getSvg(icon: string) {
    if (icon === 'weight')
        return { viewBox: '42.667 42.667 981.333 981.333', fill: 'currentColor', contents: customIcons.weight };
    else
        return { viewBox: '0 0 24 24', fill: 'none', contents: feather.icons[icon].contents };
}

export const Feather = React.memo(function Feather(props: { icon: string; size?: number; className?: string; marginTop?: number }) {
    const size = props.size ? props.size : 24;
    const className = props.className ? props.className : '';

    const svg = getSvg(props.icon);

    const content = { __html: svg.contents };

    return <svg width={size}
        height={size}
        viewBox={svg.viewBox}
        stroke="currentColor"
        fill={svg.fill}
        xmlns="http://www.w3.org/2000/svg"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        className={`feather feather-${props.icon} ${className}`}
        style={{ marginTop: props.marginTop }}
        dangerouslySetInnerHTML={content} />
})